module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group esma_form_group"
  }, [(_vm.showLabel) ? _c('label', {
    staticClass: "col-xs-4 control-label esma_form_label",
    attrs: {
      "for": _vm.fieldID
    }
  }, [_vm._v(_vm._s(_vm.fieldLabel) + "sb3")]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.fieldClass,
    staticStyle: {
      "padding": "1px 0px 1px 7px"
    }
  }, [_c('select', {
    staticClass: "form-control select-box select-box3",
    style: (_vm.filedStyle),
    attrs: {
      "disabled": _vm.isDisabled,
      "id": _vm.fieldID,
      "name": _vm.fieldID
    },
    domProps: {
      "value": _vm.fieldValue
    },
    on: {
      "change": function($event) {
        _vm.updateValue($event.target.value)
      },
      "click": _vm.onClick
    }
  }, [_vm._l((_vm.fieldOptions), function(o) {
    return _c('option', {
      key: o,
      attrs: {
        "data": o,
        "val": "."
      },
      domProps: {
        "selected": o == _vm.fieldValue
      }
    }, [_vm._v(_vm._s(_vm.specialLabels(o)))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "manual_input"
    }
  }, [_vm._v("手入力")])], 2)]), _vm._v(" "), _c('input-modal', {
    attrs: {
      "tag": 'showInputModal' + _vm.fieldID
    },
    on: {
      "inputed": _vm.onManualSelect
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7923c9d3","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fields/select-box3.vue
// module id = 1034
// module chunks = 0